
import Vue from 'vue';
import { OutlinedTextInput, TimelineItem, Button, Icon } from '@descomplica/vue-components';
import { ThesisThemeItemType } from './types';

export default Vue.extend({
  components: {
    OutlinedTextInput,
    TimelineItem,
    TextButton: Button,
    Icon,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    enabled: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    isLast: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String as Vue.PropType<ThesisThemeItemType>,
      required: true,
    },
  },
  data() {
    return {
      themeText: '',
      hasError: false,
    };
  },
  computed: {
    isThemeRejected(): boolean {
      return this.type === 'themeRejected';
    },
  },
  methods: {
    sendTccTheme() {
      this.hasError = false;
      const theme = this.themeText.trim();

      if (theme === '') {
        this.hasError = true;
        return;
      }

      this.$emit('submitTheme', this.themeText);
    },
  },
});
